var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeRedisign = function SvgGlobeRedisign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0v0Z",
    stroke: "#656B6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59 21.708C8.237 19.724 7.333 16.118 7.333 12s.904-7.724 2.257-9.708M2 12h20M3.54 17.333h16.92M3.54 6.667h16.92M14.41 2.292c1.353 1.984 2.257 5.59 2.257 9.708s-.904 7.724-2.257 9.708",
    stroke: "#656B6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgGlobeRedisign as ReactComponent };
export default __webpack_public_path__ + "9d5d3c45b1fea12b51ee3f6b8394c9a0.svg";